var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { useEffect, useState } from 'react';
import { EventEmitter } from '@ciceksepeti/cs-event-emitter';
import { Fragments } from '@ciceksepeti/cs-module-loader';
import ServerError from '@components/server-error';
import AppRoutes from '@components/app-routes';
import Events from '@constants/events';
import { FirebaseProvider } from '@contexts/firebase';
import { CommonsProvider } from '@contexts/commons';
import { getFirebaseConfig } from '@helpers/firebase-config';
import { useCommons } from '@hooks/use-commons';
import { getVariables } from '@services/common';
import './styles.module.scss';
var App = function () {
    var _a = useState(false), isLoaded = _a[0], setIsLoaded = _a[1];
    var _b = useState(false), hasServerError = _b[0], setHasServerError = _b[1];
    var setVariables = useCommons().setVariables;
    var handleInternalServerError = function (error) {
        var eventEmitter = new EventEmitter();
        var config = error.config;
        var _a = config.custom, customConfig = _a === void 0 ? {} : _a;
        var _b = customConfig.should500, should500 = _b === void 0 ? false : _b;
        if (should500) {
            setHasServerError(true);
        }
        else {
            // Wait 500ms for NotificationContainer to load
            setTimeout(function () {
                // Dispatch the event as API Error
                eventEmitter.dispatch(Events.API_ERROR_HANDLER, error);
            }, 500);
        }
    };
    var handleTimeoutError = function (error) {
        var config = error.config;
        var _a = config.custom, customConfig = _a === void 0 ? {} : _a;
        var _b = customConfig.shouldTimeOutTo500, shouldTimeOutTo500 = _b === void 0 ? false : _b;
        if (shouldTimeOutTo500) {
            setHasServerError(true);
        }
    };
    useEffect(function () {
        var eventEmitter = new EventEmitter();
        eventEmitter.subscribe(Events.SERVER_ERROR, handleInternalServerError);
        eventEmitter.subscribe(Events.TIMEOUT, handleTimeoutError);
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var commonVariables, fragments, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getVariables()];
                    case 1:
                        commonVariables = _a.sent();
                        fragments = commonVariables.fragments;
                        setVariables(commonVariables);
                        if (fragments) {
                            Fragments.init(fragments);
                        }
                        setIsLoaded(true);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            eventEmitter.unsubscribe(Events.SERVER_ERROR, handleInternalServerError);
            eventEmitter.unsubscribe(Events.TIMEOUT, handleTimeoutError);
        };
    }, [setVariables]);
    if (hasServerError)
        return _jsx(ServerError, {});
    if (!isLoaded)
        return null;
    var appRoutes = _jsx(AppRoutes, {});
    var firebaseConfig = getFirebaseConfig();
    return firebaseConfig ? (_jsx(FirebaseProvider, { config: firebaseConfig, children: appRoutes })) : (appRoutes);
};
export default App;
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(CommonsProvider, { children: _jsx(App, {}) }));
